module.exports = __webpack_public_path__ + "img/dianpubanner.6c67aa59.jpg";